import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IntegrationCard } from './integration-card'
import { KEYLESS_INTEGRATIONS_REGISTRY } from './keyless-integrations.registry'

interface KeylessIntegrationsProps {
  buildingId: number
}

export const KeylessIntegrations = ({ buildingId }: KeylessIntegrationsProps) => {
  const { t } = useTranslation(['organisation'])
  const [expandedId, setExpandedId] = useState<string | null>(null)
  // Tracks which single integration (if any) currently has a save/activate in flight, so
  // every other card can disable its own form + Save button until it clears — see AC
  // "disables new actions until previous completes".
  const [pendingId, setPendingId] = useState<string | null>(null)

  return (
    <div className="keyless-integrations">
      <h3 className="keyless-integrations__title">
        {t('organisation:places.integrations.keyless.title')}
      </h3>
      {KEYLESS_INTEGRATIONS_REGISTRY.map((config) => (
        <IntegrationCard
          key={config.id}
          buildingId={buildingId}
          config={config}
          isBlockedByOther={pendingId !== null && pendingId !== config.id}
          isOpen={expandedId === config.id}
          onPendingChange={(isPending) =>
            setPendingId((current) => {
              if (isPending) return config.id
              return current === config.id ? null : current
            })
          }
          onToggle={() => setExpandedId((current) => (current === config.id ? null : config.id))}
        />
      ))}
    </div>
  )
}
